import { PageContextConstant } from 'constants/PageContext.constants';

export const pageContextActions = {
  selectPageContext,
};

function selectPageContext(page) {
  return (dispatch) => dispatch({ type: PageContextConstant.PAGE_CURRENT, page });
}
